import { string, object } from '@gogame/schemas';

import { NAME, APPLICATION, BRIEF_URL } from './constants';

export const BriefFormValidationSchema = object({
  [NAME]: string()
    .strict()
    .trim('Name must be a trimmed string')
    .required('Name is required'),
  [APPLICATION]: string().required('Application is required'),
  [BRIEF_URL]: string()
    .strict()
    .trim('Brief must be a trimmed string')
    .required('Brief URL is required'),
});
